import { Component } from '@angular/core';
import { SuperAdminSlideComponent } from '../../components/superadmin-slide/superadmin-slide.component';
import { SuperAdminNavbarComponent } from '../../components/superadmin-navbar/superadmin-navbar.component';
import { CardComponent } from '../../components/card/card.component';
import { HostinglistComponent } from '../hostinglist/hostinglist.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
  selector: 'app-superadmin-page',
  templateUrl: './superadmin-page.component.html',
  styleUrls: ['./superadmin-page.component.css'],
  standalone: true,
  imports: [
    SuperAdminSlideComponent,
    SuperAdminNavbarComponent,
    CardComponent,
    HostinglistComponent,
    FooterComponent,
  ],
})

export class SuperAdminPageComponent {

}
